import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HotelClassIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hotel_class"}/>
}
